import { Typography, Button, makeStyles, Box } from "@material-ui/core";
import SFErrorDialog from "./SFErrorDialog";

const useStyles = makeStyles((theme) => ({
  background: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "#424242dd",
    width: "100%",
    height: "100%",
    zIndex: 999,
    display: "grid",
    placeItems: "center",
  },
  allContainer: {
    backgroundColor: theme.white,
    width: 400,
    height: 250,
    borderRadius: 12,
    position: "relative",
    display: "grid",
    gridTemplateRows: "50px auto 60px",
  },
  title: {
    fontSize: 30,
    color: theme.orange,
    marginTop: 10,
  },
  errorTitle: {
    fontSize: 30,
    color: theme.red,
    marginTop: 10,
  },
  detail: {
    fontSize: 18,
    color: theme.black,
    marginTop: 10,
    alignSelf: "center",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
  },
  button: {
    fontSize: 24,
    flex: 1,
    borderRadius: "0 0 12px 12px",
  },
  buttonLeftSide: {
    borderRadius: "0 0 0 12px",
  },
  buttonRightSide: { borderRadius: "0 0 12px 0" },
}));

const SimplePopupDialog = ({
  title = "",
  message = "",
  handleClose,
  onConfirm = () => null,
  haveCanceltoClose = false,
  confirmButton = "OK",
  cancelButton = "Cancel",
  error = false,
  logout = false,
}) => {
  const classes = useStyles();

  if (error) {
    return <ErrorDialog message={message} handleClose={handleClose} />;
  }

  if (logout) {
    return <LogoutDialog onConfirm={onConfirm} handleClose={handleClose} />;
  }

  return (
    <Box className={classes.background}>
      <Box className={classes.allContainer}>
        <Typography
          align="center"
          className={error ? classes.errorTitle : classes.title}
        >
          {title}
        </Typography>
        <Typography align="center" classes={{ root: classes.detail }}>
          {message}
        </Typography>
        <Box className={classes.buttonContainer}>
          {haveCanceltoClose && (
            <Button
              onClick={() => {
                handleClose();
              }}
              color="secondary"
              fullWidth
              variant="contained"
              className={[
                classes.button,
                haveCanceltoClose ? classes.buttonLeftSide : null,
              ]}
            >
              {cancelButton}
            </Button>
          )}
          <Button
            onClick={async () => {
              await onConfirm();
              await handleClose();
            }}
            color="primary"
            fullWidth
            variant="contained"
            className={[
              classes.button,
              haveCanceltoClose ? classes.buttonRightSide : null,
            ]}
          >
            {confirmButton}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

const ErrorDialog = ({ message, handleClose }) => {
  return <SFErrorDialog type={0} content={message} handleClose={handleClose} />;
};

const LogoutDialog = ({ handleClose, onConfirm }) => {
  return (
    <SFErrorDialog type={4} onConfirm={onConfirm} handleClose={handleClose} />
  );
};

export default SimplePopupDialog;
